import React, { useEffect } from 'react';
import './ServicesPage.css';
import { Footer } from '../components/ConstantComponent';

import { HashLink } from "react-router-hash-link";


const services = [
  {
    id: "grid-compliance",
    imagePath: require('../assets/grid-compliance-study.png'),
    serviceName: "Grid Compliance Study",
    service_desc: `
Power system compliance studies for <span class="highlight light">Wind, Solar, BESS and Hybrid projects</span> to ensure reliable grid integration and compliance with utility standards.<br><br>

Using <span class="highlight light">PSS®E</span> and <span class="highlight light">PSCAD</span>, our engineers perform Steady State, Dynamic State and Power Quality studies to evaluate system performance under normal and disturbance conditions.<br><br>

The study includes RMS & EMT modelling, short-circuit analysis, reactive capability assessment, frequency response, dynamic reactive power support and ramping capability verification, delivering complete technical documentation for successful project approval.
`
  },

  {
    id: "evacuation-study",
    imagePath: require('../assets/evacuation-study.jpg'),
    serviceName: "Evacuation Study",
    service_desc: `To assess satisfactory evacuation of proposed Wind/Solar power generation from STU/CTU Substation.

        IPR has carried out more than <span class="highlight light">50,000 MW</span> of evacuation study.

        <ul>
        <li>To perform load flow studies.</li>
        <li>Power system modelling.</li>
        <li>Collection of ongoing grid developments.</li>
        <li>Steady state power flow analysis.</li>
        <li>Transmission line adequacy checking.</li>
        <li>Voltage profile & loading analysis.</li>
        </ul>`
  },

  {
    id: "protection-study",
    imagePath: require('../assets/protection-study.png'),
    serviceName: "Protection Study",
    service_desc: `The main objective of the study is to provide protection relay setting for the project through modelling entire Wind/Solar plant SLD.

        <b>The following are the broad scope of work involved in the study:</b>

        <ul>
        <li>Overcurrent & Earth-fault protection study.</li>
        <li>Power system modelling.</li>
        <li>Short circuit study.</li>
        <li>Protection settings.</li>
        <li>Time-current curves.</li>
        <li>Protection report.</li>
        </ul>`
  },

  {
    id: "wind-solar-optimization",
    imagePath: require('../assets/optimization.jpg'),
    serviceName: "Wind/Solar Optimization",
    service_desc: `Optimisation includes detailed modelling & simulation of entire Wind/Solar plants to analyse technical parameters, investment optimisation and technical loss assessment.`
  },

  {
    id: "software-development",
    imagePath: require('../assets/software.jpg'),
    serviceName: "Software Devlopment",
    service_desc: `We have a highly experienced team in creating high-performance Mobile, Web and PC applications.

        We have built a great set of applications for our clients.`
  },

  {
    id: "technical-consultancy",
    imagePath: require('../assets/technical-consultant.jpg'),
    serviceName: "Technical Consultancy & Due-Diligence of Projects",
    service_desc: `Due-Diligence of Wind/Solar Projects to analyse loss levels and complete audit of site.`
  },

  {
    id: "transmission-planning",
    imagePath: require('../assets/planning.jpg'),
    serviceName: "Transmission Planning and Grid Studies",
    service_desc: `Load flow study Simulation of State transmission Grid network to derive Transmission system congestion.`
  },

  {
    id: "power-quality",
    imagePath: require('../assets/pq-wave.jpg'),
    serviceName: "Power Quality Measurement",
    service_desc: `Measurement of harmonics, direct current injection & flicker as per <span class="highlight light">Grid India/RLDC</span> Guidelines.`
  },

  {
    id: "power-system-consultancy",
    imagePath: require('../assets/power-system-consultancy.jpg'),
    serviceName: "Power System Consultancy",
    service_desc: `Providing technical expertise for the design of new Generation plants, transmission lines and substations.

        Assisting with feasibility studies and cost analysis.

        Ensuring designs comply with regulations and safety standards.`
  },

  {
    id: "substation-design",
    imagePath: require('../assets/substation-design.jpg'),
    serviceName: "Substation Design Consultancy",
    service_desc: `Preparation of Basic Concept Report including SLD, Layouts, Sectional Drawings, Equipment Specifications, Protection and Metering.`
  }
];

const ServicesPage = () => {

  useEffect(() => {
    const hash = window.location.hash;

    if (!hash) return;

    const id = decodeURIComponent(hash.substring(1));

    const scrollToService = () => {
      const element = document.getElementById(id);

      if (!element) {
        return false;
      }

      const navbar = document.querySelector(".navbar");
      const navbarHeight = navbar
        ? navbar.getBoundingClientRect().height
        : 0;

      const elementTop =
        element.getBoundingClientRect().top +
        window.pageYOffset;

      window.scrollTo({
        top: Math.max(0, elementTop - navbarHeight - 20),
        behavior: "smooth",
      });

      return true;
    };

    // Wait for React to finish rendering the service sections.
    let attempts = 0;

    const tryScroll = () => {
      attempts += 1;

      if (scrollToService() || attempts >= 20) {
        return;
      }

      requestAnimationFrame(tryScroll);
    };

    requestAnimationFrame(tryScroll);

    return () => {
      // Nothing to clean up because requestAnimationFrame
      // naturally stops once the element is found.
    };
  }, []);

  return (
    <div className="services2-page">

      <section className="services2-hero">
        <div className="services2-hero-overlay"></div>

        <div className="services2-hero-content">
          <p className="services2-hero-tag">OUR SERVICES</p>

          <h1 className="services2-hero-title">
            Engineering Solutions
            <br />
            For Modern Power Systems
          </h1>

          <p className="services2-hero-desc">
            Delivering reliable engineering consultancy for renewable
            energy, substations, transmission systems and software
            development.
          </p>
        </div>
      </section>

      <main className="services2-wrapper">

        {services.map((service, index) => (

          <section
            key={service.id}
            id={service.id}
            className="services2-section"
          >

            <div className="services2-image">
              <img
                src={service.imagePath}
                alt={service.serviceName}
              />
            </div>

            <div className="services2-info">

              <span className="services2-number">
                {(index + 1).toString().padStart(2, "0")}
              </span>

              <h2 className="services2-title">{service.serviceName}</h2>

              <div
                className="services2-description"
                dangerouslySetInnerHTML={{
                  __html: service.service_desc
                }}
              />

              <HashLink
                smooth
                to="/#contact"
                className="services2-btn"
              >
                Contact Our Experts
              </HashLink>

            </div>

          </section>

        ))}

      </main>

      <section className="services2-bottom-cta">

        <h2 className="services2-cta-title">Let's Build Smarter Power Systems Together</h2>

        <p className="services2-cta-desc">
          Whether you're planning renewable integration,
          transmission studies or substation engineering,
          our experts are ready to support your project.
        </p>

        <HashLink
          smooth
          to="/#contact"
          className="services2-btn"
        >
          Get In Touch
        </HashLink>

      </section>

      <Footer />

    </div>
  );
};

export default ServicesPage;